import React, { useEffect, useState } from "react";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as InventoriesActions from "../../../store/actions/Inventories";
import * as UserActions from "./../../../store/actions/User";
import {
  isValidated as isValidatedForMandatoryFields,
  filterObj,
} from "../../../utils";
import styles from "../../../constants/assets/variables";
import {
  BottomSectionModal,
  FlexContainer,
} from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import NoFooterModal from "../../Common/NoFooterModal";

const InventoriesModal = ({
  modalState,
  handleClose,
  activeFilters,
  filterFields,
  getInventoriesList,
  resetInventoriesStore,
  setStatus,
}) => {
  const [initialState, setInitialState] = useState({
    geo_type: "",
    geo_id: "",
    start_time: "",
    end_time: "",
  });

  const filterTypes = ["city", "locality", "zone"];

  const isValidated = (body) => {
    let hasNoErrors = true;
    let validationState = isValidatedForMandatoryFields(body, [
      "geo_type",
      "start_time",
      "end_time",
      "geo_id",
    ]);

    if (validationState !== "validated") {
      hasNoErrors = false;
      setStatus({
        type: "error",
        message: "All Fields are Mandatory",
      });
    }

    if (body["start_time"] && body["end_time"]) {
      let endTime = new Date(body["end_time"]);
      let startTime = new Date(body["start_time"]);
      if (startTime > endTime) {
        hasNoErrors = false;
        setStatus({
          type: "error",
          message: "Start time should be less than end time",
        });
      }
      if (Math.ceil((endTime - startTime) / (1000 * 60 * 60 * 24)) > 31) {
        hasNoErrors = false;
        setStatus({
          type: "error",
          message:
            "Duration between start time and end time should not be greater than 1 month",
        });
      }
    }
    return hasNoErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let body = filterObj(initialState, filterFields);
    if (!isValidated(body)) {
      return;
    }
    let filters = {};
    for (let key of filterFields) {
      if (body[key] !== "") {
        filters[key] = body[key] + "";
      }
    }
    filters["geo_type"] = "city";
    getInventoriesList(filters).then((_) => {
      handleClose();
    });
  };

  const handleClearFilters = () => {
    resetInventoriesStore();
    handleClose();
  };

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  useEffect(() => {
    //set the initial state of form in modal
    if (Object.keys(activeFilters).length > 0) {
      let values = { ...initialState };
      Object.keys(values).forEach((key, _) => {
        if (activeFilters[key]) {
          values[key] = activeFilters[key];
        }
      });
      setInitialState(values);
    }
  }, [activeFilters]);

  return (
    <NoFooterModal
      header
      heading={"Inventories Filter"}
      id="inventoriesFilterModal"
      handleClose={handleClose}
      modalButtons={
        <BottomSectionModal>
          <FlexContainer>
            <Button
              data-testid="saveButton"
              onClick={handleClearFilters}
              className="sushi-btn"
            >
              Clear
            </Button>
            <Button
              data-testid="applyFiltersButton"
              onClick={handleSubmit}
              className="sushi-btn"
            >
              Apply
            </Button>
          </FlexContainer>
        </BottomSectionModal>
      }
    >
      <div>
        <Input
          value={initialState.geo_id}
          onChange={(e) => handleChange("geo_id", e)}
          id="sushi-input"
          label="City Id"
          data-testId="GeoId"
          required={true}
          fullWidth={true}
          borderColor={styles.primaryColor}
          autoFocus={true}
        />
        <Input
          id="sushi-input"
          borderColor={styles.primaryColor}
          label="Start Time"
          data-testId="StartTime"
          type="date"
          value={initialState.start_time ? initialState.start_time : "  "}
          onChange={(e) => handleChange("start_time", e)}
          fullWidth={true}
        />
      </div>
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { Inventories } = state;
  return {
    activeFilters: Inventories.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetInventoriesStore: () => dispatch(InventoriesActions.resetState({})),
    getInventoriesList: bindActionCreators(
      InventoriesActions.getInventoriesList,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoriesModal);
